import { ConfigurationService } from './../shared/configuration.service';
import { PacketDetails } from './../shared/configuration.model';
import { Component, OnInit, Inject, Directive } from '@angular/core';
import { Agent } from '../shared/agent.model';
import { GCRole } from './gcrole.model';
import { AgentService } from './agent-management.service';
import { LocalStorage } from '../shared/localstorage.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MatSnackBar, MatSnackBarModule } from '@angular/material';
import { isUndefined } from 'util';
import { Validators, FormControl, NG_VALIDATORS, Form } from '@angular/forms';
import { elementAt } from '../../../../node_modules/rxjs/operators';

@Component({
  selector: 'app-agent-management',
  templateUrl: './agent-management.component.html',
  styleUrls: ['./agent-management.component.scss']
})

export class AgentManagementComponent implements OnInit {

  Agents = new Array<Agent>();
  UpdateAgents = new Array<Agent>();
  MovingAgent: Agent;
  source: any;
  UpdateTarget: HTMLElement;
  AgentsTarget: HTMLElement;
  GCRoles = new Array<GCRole>();
  QualityGroups = new Array<PacketDetails>();
  ActiveQualityGroups = new Array<PacketDetails>();
  newRole: string;
  loading = false;
  screen = false;
  userName: '';
  rangeStart: Date;
  rangeEnd: Date;
  role: number;
  property: string;

  constructor(
    private agentService: AgentService,
    private configurationService: ConfigurationService,
    private localStorage: LocalStorage,
    public dialog: MatDialog,
    public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.loading = true;
    this.agentService.getGCRoles(this.localStorage.getItem('token'), this.localStorage.getItem('currentState')).then(data => {
      this.GCRoles = data;
      this.configurationService.getPackages(this.localStorage.getItem('currentState')).subscribe(data => {
        this.QualityGroups = data;
        this.QualityGroups.forEach(element => {
          if(element.IsActive) {
            this.ActiveQualityGroups.push(element);
          }
        });
      });
      this.loading = false;
    });
  }

  DragEnter($event) {
    this.UpdateTarget = document.getElementById('Update');
    this.AgentsTarget = document.getElementById('Agents');

    if (($event.target === this.UpdateTarget.parentNode
      || $event.target === this.UpdateTarget
      || $event.target.parentNode === this.UpdateTarget)
      && this.UpdateAgents.findIndex(x => x.Username === this.MovingAgent.Username) === -1) {
      this.UpdateAgents.push(this.MovingAgent);
      this.Agents.splice(this.Agents.findIndex(x => x.Username === this.MovingAgent.Username), 1);
    } else if (($event.target === this.AgentsTarget.parentNode
      || $event.target === this.AgentsTarget
      || $event.target.parentNode === this.AgentsTarget)
      && this.Agents.findIndex(x => x.Username === this.MovingAgent.Username) === -1) {
      this.Agents.push(this.MovingAgent);
      this.UpdateAgents.splice(this.UpdateAgents.findIndex(x => x.Username === this.MovingAgent.Username), 1);
      if (this.UpdateAgents.length === 0) {
        this.newRole = null;
      }
    }
  }

  DragStart($event, agent) {
    this.source = $event.target;
    this.MovingAgent = agent;
    $event.dataTransfer.effectAllowed = 'move';
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ConfirmUpdateComponent, {
      width: '500px',
      data: { agents: this.UpdateAgents, role: this.newRole },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Confirm') {
        // set update items new property and update db
        this.screen = true;
        const AgentIds = new Array<string>();
        this.UpdateAgents.forEach(agent => {
          AgentIds.push(agent.Username);
        });
        this.agentService.UpdateAgents(AgentIds, this.newRole, this.localStorage.getItem('token'), this.localStorage.getItem('currentState')).then(data => {
          this.snackBar.open(data.length.toString() + ' agents updated successfully.', 'Dismiss', {
            verticalPosition: 'top',
            duration: 5000
          });
          this.UpdateAgents = new Array<Agent>();
          this.Agents = new Array<Agent>();
          this.userName = '';
          this.rangeStart = null;
          this.rangeEnd = null;
          this.role = 0;
          this.property = '';
          this.newRole = '';
          this.screen = false;
        });
      }
    });
  }

  Search() {
    if ((!isUndefined(this.userName) && this.userName.length > 2)
      || (!isUndefined(this.rangeStart) && this.rangeStart !== null && !isUndefined(this.rangeEnd) && this.rangeEnd !== null
        && this.rangeEnd >= this.rangeStart
        && Date.parse(this.rangeEnd.toString()) - Date.parse(this.rangeStart.toString()) <= 2678400000)) {
      this.screen = true;
      let rangeStart = '';
      let rangeEnd = '';
      if (this.rangeStart) {
        rangeStart = this.rangeStart.toDateString();
      }
      if (this.rangeEnd) {
        rangeEnd = this.rangeEnd.toDateString();
      }
      this.agentService.GetAgents(this.localStorage.getItem('token'), this.userName, rangeStart, rangeEnd, this.role, this.property, this.localStorage.getItem('currentState'))
        .then(data => {
          this.Agents = data;
          this.UpdateAgents = new Array<Agent>();
          this.screen = false;
        });
    } else {
      // do something to show not valid
    }
  }
}

export function agentSearchValidator(control: FormControl) {
  let userName = '';
  let rangeStart;
  let rangeEnd;
  if (control.dirty) {
    if (!isUndefined(control.get('userName'))) {
      if (!isUndefined(control.get('userName').value)) {
        userName = control.get('userName').value;
      }
    }
    if (!isUndefined(control.get('rangeStart')) && !isUndefined(control.get('rangeEnd'))) {
      if (!isUndefined(control.get('rangeStart').value) && !isUndefined(control.get('rangeEnd').value)
        && control.get('rangeStart').value !== null && control.get('rangeEnd').value !== null) {
        rangeStart = control.get('rangeStart').value;
        rangeEnd = control.get('rangeEnd').value;
        if (rangeStart > rangeEnd) {
          return {
            appAgentSearch: {
              dateRange: 'invalid.'
            }
          };
        }
        if (Date.parse(rangeEnd.toString()) - Date.parse(rangeStart.toString()) > 2678400000) {
          if (userName === '' || userName.length < 3) {
            return {
              appAgentSearch: {
                maxDateRange: 'invalid.'
              }
            };
          }
        }
      } else if (((isUndefined(control.get('rangeStart').value) || control.get('rangeStart').value === null)
        && control.get('rangeEnd').value !== null && !isUndefined(control.get('rangeEnd').value))
        || (!isUndefined(control.get('rangeStart').value) && control.get('rangeStart').value !== null
          && (isUndefined(control.get('rangeEnd').value) || control.get('rangeStart').value !== null))) {
        return {
          appAgentSearch: {
            dateRange: 'invalid.'
          }
        };
      }

      if ((isUndefined(control.get('rangeStart').value) || control.get('rangeStart').value == null)
        && (isUndefined(control.get('rangeEnd').value) || control.get('rangeEnd').value == null)
        && userName !== '' && userName.length < 3) {
        return {
          appAgentSearch: {
            userName: 'invalid'
          }
        };
      }
    }

    if ((!isUndefined(userName) && userName.length > 2)
      || (!isUndefined(rangeStart) && !isUndefined(rangeEnd) && rangeEnd >= rangeStart
        && Date.parse(rangeEnd.toString()) - Date.parse(rangeStart.toString()) <= 2678400000)) {
      return null;
    } else {
      return {
        appAgentSearch: {
          searchCriteria: 'invalid'
        }
      };
    }

  }
}

@Directive({
  selector: '[appAgentSearch]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useValue: agentSearchValidator,
      multi: true
    }
  ]
})
export class AgentSearchValidatorDirective {
}

@Component({
  selector: 'app-confirm-update-dialog',
  templateUrl: 'app-confirm-update-dialog.html',
  // styleUrls: ['./qaticket-config.component.css']
})
export class ConfirmUpdateComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmUpdateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
  ngOnInit() {

  }

  onSubmit() {
    this.dialogRef.close('Confirm');
  }

  onCancelClick(): void {
    this.dialogRef.close('Cancel');
  }
}
